import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import Image from '@base/lib/ThemeImage';
import { Trans } from 'base/utils/i18n';
import { useStoreState } from 'base/store'

type IProps = {
    showTitle?: boolean;
}

const I18nKeys = {
    US: {
        title: 'web_product_affirm_pay_title_us',
        msg: 'web_product_affirm_pay_help_us',
    },
}

const links = {
    lenders: 'https://www.affirm.com/lenders',
    terms: 'https://www.affirm.com/terms',
    privacy: 'https://www.affirm.com/privacy',
}

const AffirmPayInfo: React.FC<IProps> = (props) => {
    const {
        showTitle = true
    } = props

    const { country } = useStoreState('rootStore');

    const _i18nKeys = I18nKeys[country];

    return (
        <div className={cn('text-center', styles['after-pay-info'])}>

            {showTitle && (
                <div className={styles['title-img']}>
                    <Image
                        src={'asset/width-264/picture/3886cb9b28d65ff863c8f97e2369e917.png'}
                        width={98}
                        height={38}
                        fixed
                        background={false}
                    />
                </div>
            )}

            <div className={styles['sub-title']}>
                <Trans
                    i18nKey={_i18nKeys.title}
                    components={{ br: <br/> }}
                />
            </div>

            <div className={styles.msg}>
                <Trans
                    i18nKey={_i18nKeys.msg}
                    components={{
                        Div: <div/>,
                        P: <p/>,
                        Lenders: <a href={links.lenders} target={"_blank"} rel="noopener noreferrer"/>,
                        Terms: <a href={links.terms} target={"_blank"} rel="noopener noreferrer"/>,
                        Privacy: <a href={links.privacy} target={"_blank"} rel="noopener noreferrer"/>,
                    }}
                />
            </div>
        </div>
    );
};

export default AffirmPayInfo